import React from 'react';

const labels = {
  ne: {
    title: 'उप-क्षेत्र तथा मुख्य कार्यक्षेत्रहरू',
    subtitle: 'यस प्राथमिकता क्षेत्र अन्तर्गत पहिचान गरिएका मुख्य उप-क्षेत्रहरू।',
  },
  en: {
    title: 'Sub-sectors & Key Focus Areas',
    subtitle: 'Key focus areas and strategic sub-sectors identified under this Priority Area.',
  },
};

const SubSectorSection = ({ subSectors, language = 'ne' }) => {
  if (!subSectors || subSectors.length === 0) {
    return null;
  }

  const t = labels[language] || labels.ne;

  return (
    <section className="sub-sectors" id="sub-sectors">
      <div className="container">
        {/* Section Header */}
        <div className="section-header sub-sectors__header">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </div>

        {/* Vertical Sub-sectors List */}
        <div className="sub-sectors__list-wrapper">
          <ul className="sub-sectors__vertical-list" role="list">
            {subSectors.map((subSector, index) => {
              const title = typeof subSector === 'string' ? subSector : (subSector.title || subSector.name || '');
              const description = typeof subSector === 'object' ? subSector.description : '';

              return (
                <li key={index} className="sub-sector-list-item">
                  <span className="sub-sector-list-item__bullet" aria-hidden="true" />
                  <div className="sub-sector-list-item__content">
                    <span className="sub-sector-list-item__title">{title}</span>
                    {description ? (
                      <p className="sub-sector-list-item__description">{description}</p>
                    ) : null}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SubSectorSection;
